// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const HeroSection = () => {
//     const navigate = useNavigate();
//     const [activeIndex, setActiveIndex] = useState(0);
//     const [isVisible, setIsVisible] = useState(false);

//     const features = [
//         {
//             icon: "🧹",
//             title: "Smart Cleaning",
//             desc: "AI-powered cleaning schedules and task automation",
//             stat: "+45%",
//             statLabel: "Efficiency"
//         },
//         {
//             icon: "📊",
//             title: "Real-time Analytics",
//             desc: "Live dashboard with performance metrics and insights",
//             stat: "98%",
//             statLabel: "Accuracy"
//         },
//         {
//             icon: "📦",
//             title: "Inventory Control",
//             desc: "Automated supply tracking and reorder alerts",
//             stat: "30%",
//             statLabel: "Savings"
//         },
//         {
//             icon: "👥",
//             title: "Team Management",
//             desc: "Staff scheduling, tracking, and performance reports",
//             stat: "24/7",
//             statLabel: "Support"
//         }
//     ];

//     useEffect(() => {
//         setIsVisible(true);
//         const timer = setInterval(() => {
//             setActiveIndex((prev) => (prev + 1) % features.length);
//         }, 3000);
//         return () => clearInterval(timer);
//     }, []);

//     return (
//         <section className="relative w-full overflow-hidden bg-white">
//             <div className="relative w-full min-h-[550px] sm:min-h-[650px] md:min-h-[750px] flex items-center">
                
//                 {/* Animated Background */}
//                 <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50/40 to-white animate-gradient" />
                
//                 {/* Animated Pattern */}
//                 <div className="absolute inset-0 opacity-20">
//                     <div className="absolute inset-0 animate-pattern" style={{
//                         backgroundImage: `radial-gradient(circle at 1px 1px, #3b82f6 0.5px, transparent 0.5px)`,
//                         backgroundSize: '32px 32px'
//                     }} />
//                 </div>

//                 {/* Animated Blobs */}
//                 <div className="absolute inset-0 overflow-hidden">
//                     <div className="absolute -top-32 -right-32 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl animate-blob" />
//                     <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-blue-50/40 rounded-full blur-3xl animate-blob animation-delay-2000" />
//                     <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-blue-100/20 rounded-full blur-3xl animate-blob animation-delay-4000" />
//                 </div>

//                 {/* Animated Particles */}
//                 <div className="absolute inset-0 pointer-events-none">
//                     {[...Array(20)].map((_, i) => (
//                         <div
//                             key={i}
//                             className="absolute w-1 h-1 bg-blue-400/30 rounded-full animate-particle"
//                             style={{
//                                 top: `${Math.random() * 100}%`,
//                                 left: `${Math.random() * 100}%`,
//                                 animationDelay: `${Math.random() * 5}s`,
//                                 animationDuration: `${3 + Math.random() * 4}s`
//                             }}
//                         />
//                     ))}
//                 </div>

//                 <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//                     <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                        
//                         {/* Left Column - Animated */}
//                         <div className={`text-center lg:text-left transition-all duration-700 transform ${
//                             isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'
//                         }`}>
//                             {/* Badge */}
//                             <div className="inline-flex items-center gap-2 bg-blue-50 rounded-full px-4 py-1.5 mb-5 animate-slide-down">
//                                 <span className="w-2 h-2 rounded-full bg-blue-500 animate-ping" />
//                                 <span className="text-xs font-semibold text-blue-700 tracking-wide animate-pulse-slow">HOUSEKEEPING MANAGEMENT</span>
//                             </div>

//                             {/* Heading with letter animation */}
//                             <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-slate-800 leading-tight">
//                                 <span className="block animate-slide-right">Smart</span>
//                                 <span className="block text-blue-600 mt-1 animate-slide-right animation-delay-200">
//                                     Housekeeping
//                                 </span>
//                                 <span className="block text-slate-800 mt-1 animate-slide-right animation-delay-400">
//                                     Management
//                                 </span>
//                             </h1>

//                             {/* Description */}
//                             <p className="mt-5 text-base sm:text-lg text-slate-600 max-w-lg mx-auto lg:mx-0 leading-relaxed animate-fade-up animation-delay-600">
//                                 Streamline your facility operations with{" "}
//                                 <span className="text-blue-600 font-semibold relative inline-block group">
//                                     AI-powered housekeeping system
//                                     <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
//                                 </span>
//                                 . Automate tasks, track inventory, and optimize staff efficiency.
//                             </p>

//                             {/* Buttons */}
//                             <div className="mt-7 flex flex-wrap gap-4 justify-center lg:justify-start animate-fade-up animation-delay-800">
//                                 <button
//                                     onClick={() => navigate('/dashboard')}
//                                     className="group relative px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl transition-all duration-300 shadow-md hover:shadow-lg active:scale-95 overflow-hidden"
//                                 >
//                                     <span className="relative z-10">Get Started</span>
//                                     <span className="absolute inset-0 bg-blue-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
//                                 </button>
                               
//                             </div>

//                             {/* Stats Row */}
                           
//                         </div>

//                         {/* Right Column - Animated Card with enhanced animations */}
//                         <div className={`relative hidden lg:block transition-all duration-700 transform ${
//                             isVisible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
//                         }`}>
//                             {/* Floating elements background */}
//                             <div className="absolute -top-10 -right-10 w-40 h-40 bg-blue-100/30 rounded-full blur-2xl animate-pulse-slow" />
//                             <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-blue-100/30 rounded-full blur-2xl animate-pulse-slow animation-delay-2000" />

//                             {/* Main Card */}
//                             <div className="relative bg-white rounded-2xl shadow-xl border border-blue-100 overflow-hidden animate-zoom-in">
//                                 {/* Card Header with shine effect */}
//                                 <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-5 py-4 relative overflow-hidden">
//                                     <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shine"></div>
//                                     <div className="flex items-center justify-between">
//                                         <div>
//                                             <div className="text-blue-100 text-[10px] font-semibold tracking-wider animate-slide-down">LIVE OVERVIEW</div>
//                                             <div className="text-white font-semibold text-base mt-0.5 animate-slide-right">Housekeeping Dashboard</div>
//                                         </div>
//                                         <div className="flex items-center gap-1 animate-pulse-slow">
//                                             <div className="w-2 h-2 rounded-full bg-green-400 animate-ping" />
//                                             <span className="text-[10px] text-blue-100">Live</span>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Card Body */}
//                                 <div className="p-5">
//                                     {/* Animated Feature Slider */}
//                                     <div className="relative min-h-[220px]">
//                                         {features.map((feature, idx) => (
//                                             <div
//                                                 key={idx}
//                                                 className={`absolute inset-0 transition-all duration-500 ease-out ${
//                                                     idx === activeIndex
//                                                         ? "opacity-100 translate-x-0 scale-100"
//                                                         : idx < activeIndex
//                                                         ? "opacity-0 -translate-x-8 scale-95"
//                                                         : "opacity-0 translate-x-8 scale-95"
//                                                 }`}
//                                             >
//                                                 <div className="text-center">
//                                                     {/* Icon with bounce animation */}
//                                                     <div className="text-5xl mb-3 animate-bounce-in">
//                                                         {feature.icon}
//                                                     </div>
                                                    
//                                                     {/* Title */}
//                                                     <h4 className="text-lg font-bold text-slate-800 mb-2 animate-slide-up">
//                                                         {feature.title}
//                                                     </h4>
                                                    
//                                                     {/* Description */}
//                                                     <p className="text-slate-500 text-sm leading-relaxed mb-4 px-2 animate-fade-in">
//                                                         {feature.desc}
//                                                     </p>
                                                    
//                                                     {/* Stat Badge */}
//                                                     <div className="inline-flex items-baseline gap-1 bg-blue-50 rounded-full px-4 py-1.5 hover:scale-105 transition-transform duration-300 cursor-default">
//                                                         <span className="text-xl font-bold text-blue-600 animate-count-up">
//                                                             {feature.stat}
//                                                         </span>
//                                                         <span className="text-xs text-slate-500">{feature.statLabel}</span>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>

//                                     {/* Progress Dots */}
//                                     <div className="flex justify-center gap-2 mt-4 pt-2">
//                                         {features.map((_, idx) => (
//                                             <button
//                                                 key={idx}
//                                                 onClick={() => setActiveIndex(idx)}
//                                                 className={`transition-all duration-300 rounded-full transform hover:scale-125 ${
//                                                     idx === activeIndex
//                                                         ? "w-6 h-1.5 bg-blue-500"
//                                                         : "w-1.5 h-1.5 bg-blue-200 hover:bg-blue-300"
//                                                 }`}
//                                             />
//                                         ))}
//                                     </div>
//                                 </div>

//                                 {/* Card Footer */}
//                                 <div className="border-t border-blue-100 px-5 py-3 bg-blue-50/20 flex justify-between items-center">
//                                     <div className="flex items-center gap-2 group cursor-pointer">
//                                         <svg className="w-3.5 h-3.5 text-blue-500 group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                                         </svg>
//                                         <span className="text-xs text-slate-600 group-hover:text-blue-600 transition-colors duration-300">Real-time sync</span>
//                                     </div>
//                                     <div className="flex items-center gap-2">
//                                         <div className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
//                                         <span className="text-[10px] text-slate-400">Updated now</span>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Animated Floating Mini Cards */}
//                             <div className="absolute -left-8 bottom-8 bg-white rounded-xl shadow-md p-2.5 border border-blue-100 animate-float-slow hover:scale-105 transition-transform duration-300">
//                                 <div className="flex items-center gap-2">
//                                     <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center animate-bounce-in">
//                                         <span className="text-lg">✓</span>
//                                     </div>
//                                     <div>
//                                         <div className="text-[10px] text-slate-500">Today's Tasks</div>
//                                         <div className="text-sm font-bold text-slate-800">
//                                             24/32 <span className="text-green-600 text-[10px] animate-pulse-slow">completed</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="absolute -right-8 top-12 bg-white rounded-xl shadow-md p-2.5 border border-blue-100 animate-float hover:scale-105 transition-transform duration-300 animation-delay-1000">
//                                 <div className="flex items-center gap-2">
//                                     <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center animate-spin-slow">
//                                         <span className="text-lg">🧹</span>
//                                     </div>
//                                     <div>
//                                         <div className="text-[10px] text-slate-500">Staff on Duty</div>
//                                         <div className="text-sm font-bold text-slate-800">
//                                             18 <span className="text-blue-600 text-[10px]">active</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <style>{`
//                 /* Base Animations */
//                 @keyframes float {
//                     0%, 100% { transform: translateY(0px); }
//                     50% { transform: translateY(-8px); }
//                 }
//                 @keyframes floatSlow {
//                     0%, 100% { transform: translateY(0px); }
//                     50% { transform: translateY(-5px); }
//                 }
//                 @keyframes blob {
//                     0%, 100% { transform: translate(0px, 0px) scale(1); }
//                     33% { transform: translate(30px, -20px) scale(1.1); }
//                     66% { transform: translate(-20px, 20px) scale(0.9); }
//                 }
//                 @keyframes shine {
//                     100% { transform: translateX(100%); }
//                 }
//                 @keyframes slideDown {
//                     from { opacity: 0; transform: translateY(-20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes slideRight {
//                     from { opacity: 0; transform: translateX(-30px); }
//                     to { opacity: 1; transform: translateX(0); }
//                 }
//                 @keyframes slideUp {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes fadeUp {
//                     from { opacity: 0; transform: translateY(30px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes fadeIn {
//                     from { opacity: 0; }
//                     to { opacity: 1; }
//                 }
//                 @keyframes zoomIn {
//                     from { opacity: 0; transform: scale(0.9); }
//                     to { opacity: 1; transform: scale(1); }
//                 }
//                 @keyframes bounceIn {
//                     0% { opacity: 0; transform: scale(0.3); }
//                     50% { opacity: 1; transform: scale(1.05); }
//                     70% { transform: scale(0.9); }
//                     100% { transform: scale(1); }
//                 }
//                 @keyframes countUp {
//                     from { opacity: 0; transform: translateY(10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes particle {
//                     0% { transform: translateY(0px) scale(1); opacity: 0; }
//                     50% { opacity: 0.5; }
//                     100% { transform: translateY(-100px) scale(0); opacity: 0; }
//                 }
//                 @keyframes gradient {
//                     0% { background-position: 0% 50%; }
//                     50% { background-position: 100% 50%; }
//                     100% { background-position: 0% 50%; }
//                 }
//                 @keyframes pattern {
//                     0% { transform: translateX(0px) translateY(0px); }
//                     100% { transform: translateX(32px) translateY(32px); }
//                 }

//                 /* Animation Classes */
//                 .animate-float { animation: float 3s ease-in-out infinite; }
//                 .animate-float-slow { animation: floatSlow 4s ease-in-out infinite; }
//                 .animate-blob { animation: blob 7s ease-in-out infinite; }
//                 .animate-shine { animation: shine 2s infinite; }
//                 .animate-slide-down { animation: slideDown 0.6s ease-out forwards; }
//                 .animate-slide-right { animation: slideRight 0.6s ease-out forwards; opacity: 0; animation-fill-mode: forwards; }
//                 .animate-slide-up { animation: slideUp 0.6s ease-out forwards; }
//                 .animate-fade-up { animation: fadeUp 0.8s ease-out forwards; opacity: 0; animation-fill-mode: forwards; }
//                 .animate-fade-in { animation: fadeIn 0.5s ease-out forwards; }
//                 .animate-zoom-in { animation: zoomIn 0.6s ease-out forwards; }
//                 .animate-bounce-in { animation: bounceIn 0.6s ease-out; }
//                 .animate-count-up { animation: countUp 0.8s ease-out forwards; }
//                 .animate-particle { animation: particle 4s ease-in-out infinite; }
//                 .animate-gradient { background-size: 200% 200%; animation: gradient 8s ease infinite; }
//                 .animate-pattern { animation: pattern 20s linear infinite; }
//                 .animate-pulse-slow { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
//                 .animate-pulse-hover:hover { animation: pulse 0.5s ease-in-out; }
//                 .animate-spin-slow { animation: spin 3s linear infinite; }

//                 /* Animation Delays */
//                 .animation-delay-200 { animation-delay: 0.2s; }
//                 .animation-delay-400 { animation-delay: 0.4s; }
//                 .animation-delay-600 { animation-delay: 0.6s; }
//                 .animation-delay-800 { animation-delay: 0.8s; }
//                 .animation-delay-1000 { animation-delay: 1s; }
//                 .animation-delay-2000 { animation-delay: 2s; }
//                 .animation-delay-4000 { animation-delay: 4s; }
//             `}</style>
//         </section>
//     );
// };

// export default HeroSection;


import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Import images
import smartImg from "../assets/images/smart.jpeg";
import teamImg from "../assets/images/team.jpeg";
import inveImg from "../assets/images/inventory.jpeg";
import realtimeImg from "../assets/images/realtime.jpeg";

const HeroSection = () => {
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    const images = [
        {
            src: smartImg,
            title: "Smart Cleaning",
            // description: "AI-powered cleaning schedules and task automation",
            // stat: "+45%",
            statLabel: "Efficiency"
        },
        {
            src: teamImg,
             title: "Team Management",
            // description: "Staff scheduling, tracking, and performance reports",
            // stat: "24/7",
            statLabel: "Support"
        },
        {
            src: inveImg,
             title: "Inventory Control",
            // description: "Automated supply tracking and reorder alerts",
            // stat: "30%",
            statLabel: "Savings"
        },
        {
            src: realtimeImg,
            title: "Real-time Analytics",
            // description: "Live dashboard with performance metrics and insights",
            // stat: "98%",
            statLabel: "Accuracy"
        }
    ];

    useEffect(() => {
        setIsVisible(true);
        const timer = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % images.length);
        }, 4000);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className="relative w-full overflow-hidden bg-white">
            <div className="relative w-full min-h-[550px] sm:min-h-[650px] md:min-h-[750px] flex items-center">
                
                {/* Animated Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50/40 to-white animate-gradient" />
                
                {/* Animated Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="absolute inset-0 animate-pattern" style={{
                        backgroundImage: `radial-gradient(circle at 1px 1px, #3b82f6 0.5px, transparent 0.5px)`,
                        backgroundSize: '32px 32px'
                    }} />
                </div>

                {/* Animated Blobs */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute -top-32 -right-32 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl animate-blob" />
                    <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-blue-50/40 rounded-full blur-3xl animate-blob animation-delay-2000" />
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-blue-100/20 rounded-full blur-3xl animate-blob animation-delay-4000" />
                </div>

                {/* Animated Particles */}
                <div className="absolute inset-0 pointer-events-none">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-1 h-1 bg-blue-400/30 rounded-full animate-particle"
                            style={{
                                top: `${Math.random() * 100}%`,
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 5}s`,
                                animationDuration: `${3 + Math.random() * 4}s`
                            }}
                        />
                    ))}
                </div>

                <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                        
                        {/* Left Column - Animated */}
                        <div className={`text-center lg:text-left transition-all duration-700 transform ${
                            isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'
                        }`}>
                            {/* Badge */}
                            <div className="inline-flex items-center gap-2 bg-blue-50 rounded-full px-4 py-1.5 mb-5 animate-slide-down">
                                <span className="w-2 h-2 rounded-full bg-blue-500 animate-ping" />
                                <span className="text-xs font-semibold text-blue-700 tracking-wide animate-pulse-slow">HOUSEKEEPING MANAGEMENT</span>
                            </div>

                            {/* Heading with letter animation */}
                            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-slate-800 leading-tight">
                                <span className="block animate-slide-right">Smart</span>
                                <span className="block text-blue-600 mt-1 animate-slide-right animation-delay-200">
                                    Housekeeping
                                </span>
                                <span className="block text-slate-800 mt-1 animate-slide-right animation-delay-400">
                                    Management
                                </span>
                            </h1>

                            {/* Description */}
                            <p className="mt-5 text-base sm:text-lg text-slate-600 max-w-lg mx-auto lg:mx-0 leading-relaxed animate-fade-up animation-delay-600">
                                Streamline your facility operations with{" "}
                                <span className="text-blue-600 font-semibold relative inline-block group">
                                    AI-powered housekeeping system
                                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                                </span>
                                . Automate tasks, track inventory, and optimize staff efficiency.
                            </p>

                            {/* Buttons */}
                            <div className="mt-7 flex flex-wrap gap-4 justify-center lg:justify-start animate-fade-up animation-delay-800">
                                <button
                                    onClick={() => navigate('/dashboard')}
                                    className="group relative px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl transition-all duration-300 shadow-md hover:shadow-lg active:scale-95 overflow-hidden"
                                >
                                    <span className="relative z-10">Get Started</span>
                                    <span className="absolute inset-0 bg-blue-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                                </button>
                            </div>
                        </div>

                        {/* Right Column - Animated Image Slider */}
                        <div className={`relative hidden lg:block transition-all duration-700 transform ${
                            isVisible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
                        }`}>
                            {/* Floating elements background */}
                            <div className="absolute -top-10 -right-10 w-40 h-40 bg-blue-100/30 rounded-full blur-2xl animate-pulse-slow" />
                            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-blue-100/30 rounded-full blur-2xl animate-pulse-slow animation-delay-2000" />

                            {/* Main Card */}
                            <div className="relative bg-white rounded-2xl shadow-xl border border-blue-100 overflow-hidden animate-zoom-in">
                                {/* Card Header with shine effect */}
                                <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-5 py-4 relative overflow-hidden">
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shine"></div>
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <div className="text-blue-100 text-[10px] font-semibold tracking-wider animate-slide-down">FEATURE HIGHLIGHTS</div>
                                            <div className="text-white font-semibold text-base mt-0.5 animate-slide-right">Housekeeping Solutions</div>
                                        </div>
                                        <div className="flex items-center gap-1 animate-pulse-slow">
                                            <div className="w-2 h-2 rounded-full bg-green-400 animate-ping" />
                                            <span className="text-[10px] text-blue-100">Live</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Card Body with Image Slider */}
                                <div className="p-5">
                                    {/* Animated Image Slider */}
                                    <div className="relative min-h-[320px]">
                                        {images.map((image, idx) => (
                                            <div
                                                key={idx}
                                                className={`absolute inset-0 transition-all duration-700 ease-out ${
                                                    idx === activeIndex
                                                        ? "opacity-100 translate-x-0 scale-100"
                                                        : idx < activeIndex
                                                        ? "opacity-0 -translate-x-8 scale-95"
                                                        : "opacity-0 translate-x-8 scale-95"
                                                }`}
                                            >
                                                <div className="text-center">
                                                    {/* Image */}
                                                    <div className="mb-4 overflow-hidden rounded-xl">
                                                        <img 
                                                            src={image.src} 
                                                            alt={image.title}
                                                            className="w-full h-48 object-cover rounded-xl shadow-md transform transition-transform duration-500 hover:scale-105"
                                                        />
                                                    </div>
                                                    
                                                    {/* Title */}
                                                    <h4 className="text-lg font-bold text-slate-800 mb-2 animate-slide-up">
                                                        {image.title}
                                                    </h4>
                                                    
                                                    {/* Description */}
                                                    <p className="text-slate-500 text-sm leading-relaxed mb-4 px-2 animate-fade-in">
                                                        {image.description}
                                                    </p>
                                                    
                                                    {/* Stat Badge */}
                                                    <div className="inline-flex items-baseline gap-1 bg-blue-50 rounded-full px-4 py-1.5 hover:scale-105 transition-transform duration-300 cursor-default">
                                                        <span className="text-xl font-bold text-blue-600 animate-count-up">
                                                            {image.stat}
                                                        </span>
                                                        <span className="text-xs text-slate-500">{image.statLabel}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Progress Dots */}
                                    <div className="flex justify-center gap-2 mt-6 pt-2">
                                        {images.map((_, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() => setActiveIndex(idx)}
                                                className={`transition-all duration-300 rounded-full transform hover:scale-125 ${
                                                    idx === activeIndex
                                                        ? "w-8 h-1.5 bg-blue-500"
                                                        : "w-1.5 h-1.5 bg-blue-200 hover:bg-blue-300"
                                                }`}
                                            />
                                        ))}
                                    </div>
                                </div>

                                {/* Card Footer */}
                                <div className="border-t border-blue-100 px-5 py-3 bg-blue-50/20 flex justify-between items-center">
                                    <div className="flex items-center gap-2 group cursor-pointer">
                                        <svg className="w-3.5 h-3.5 text-blue-500 group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                        <span className="text-xs text-slate-600 group-hover:text-blue-600 transition-colors duration-300">Real-time sync</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <div className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
                                        <span className="text-[10px] text-slate-400">Updated now</span>
                                    </div>
                                </div>
                            </div>

                            {/* Animated Floating Mini Cards */}
                            <div className="absolute -left-8 bottom-8 bg-white rounded-xl shadow-md p-2.5 border border-blue-100 animate-float-slow hover:scale-105 transition-transform duration-300">
                                <div className="flex items-center gap-2">
                                    <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center animate-bounce-in">
                                        <span className="text-lg">✓</span>
                                    </div>
                                    <div>
                                        <div className="text-[10px] text-slate-500">Today's Tasks</div>
                                        <div className="text-sm font-bold text-slate-800">
                                            24/32 <span className="text-green-600 text-[10px] animate-pulse-slow">completed</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute -right-8 top-12 bg-white rounded-xl shadow-md p-2.5 border border-blue-100 animate-float hover:scale-105 transition-transform duration-300 animation-delay-1000">
                                <div className="flex items-center gap-2">
                                    <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center animate-spin-slow">
                                        <span className="text-lg">🧹</span>
                                    </div>
                                    <div>
                                        <div className="text-[10px] text-slate-500">Staff on Duty</div>
                                        <div className="text-sm font-bold text-slate-800">
                                            18 <span className="text-blue-600 text-[10px]">active</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                /* Base Animations */
                @keyframes float {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-8px); }
                }
                @keyframes floatSlow {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-5px); }
                }
                @keyframes blob {
                    0%, 100% { transform: translate(0px, 0px) scale(1); }
                    33% { transform: translate(30px, -20px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                }
                @keyframes shine {
                    100% { transform: translateX(100%); }
                }
                @keyframes slideDown {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideRight {
                    from { opacity: 0; transform: translateX(-30px); }
                    to { opacity: 1; transform: translateX(0); }
                }
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes fadeUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes zoomIn {
                    from { opacity: 0; transform: scale(0.9); }
                    to { opacity: 1; transform: scale(1); }
                }
                @keyframes bounceIn {
                    0% { opacity: 0; transform: scale(0.3); }
                    50% { opacity: 1; transform: scale(1.05); }
                    70% { transform: scale(0.9); }
                    100% { transform: scale(1); }
                }
                @keyframes countUp {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes particle {
                    0% { transform: translateY(0px) scale(1); opacity: 0; }
                    50% { opacity: 0.5; }
                    100% { transform: translateY(-100px) scale(0); opacity: 0; }
                }
                @keyframes gradient {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                @keyframes pattern {
                    0% { transform: translateX(0px) translateY(0px); }
                    100% { transform: translateX(32px) translateY(32px); }
                }

                /* Animation Classes */
                .animate-float { animation: float 3s ease-in-out infinite; }
                .animate-float-slow { animation: floatSlow 4s ease-in-out infinite; }
                .animate-blob { animation: blob 7s ease-in-out infinite; }
                .animate-shine { animation: shine 2s infinite; }
                .animate-slide-down { animation: slideDown 0.6s ease-out forwards; }
                .animate-slide-right { animation: slideRight 0.6s ease-out forwards; opacity: 0; animation-fill-mode: forwards; }
                .animate-slide-up { animation: slideUp 0.6s ease-out forwards; }
                .animate-fade-up { animation: fadeUp 0.8s ease-out forwards; opacity: 0; animation-fill-mode: forwards; }
                .animate-fade-in { animation: fadeIn 0.5s ease-out forwards; }
                .animate-zoom-in { animation: zoomIn 0.6s ease-out forwards; }
                .animate-bounce-in { animation: bounceIn 0.6s ease-out; }
                .animate-count-up { animation: countUp 0.8s ease-out forwards; }
                .animate-particle { animation: particle 4s ease-in-out infinite; }
                .animate-gradient { background-size: 200% 200%; animation: gradient 8s ease infinite; }
                .animate-pattern { animation: pattern 20s linear infinite; }
                .animate-pulse-slow { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
                .animate-spin-slow { animation: spin 3s linear infinite; }

                /* Animation Delays */
                .animation-delay-200 { animation-delay: 0.2s; }
                .animation-delay-400 { animation-delay: 0.4s; }
                .animation-delay-600 { animation-delay: 0.6s; }
                .animation-delay-800 { animation-delay: 0.8s; }
                .animation-delay-1000 { animation-delay: 1s; }
                .animation-delay-2000 { animation-delay: 2s; }
                .animation-delay-4000 { animation-delay: 4s; }
            `}</style>
        </section>
    );
};

export default HeroSection;